import { defineStore } from 'pinia'
import actions from './actions'
import mutations from './mutations'

export const useCommentsStore = defineStore('comments', {
  state: () => ({
    // 用户权限
    userAuthority: '',
    // 评论列表
    comments: [],
    // 剩余未读
    remainCount: null,
    // 总评论数
    totalCount: null,
    // 1可以评论 ；2不可评论，不可开启 3暂时关闭，2或3即都不可评论
    commentsStatus: 0,
    // 是否有新消息提示
    hasNewMessage: false,
    // 引用内容评论
    quoteData: null
  }),
  getters: {
    // comments 是否不可评论 1可以评论 2不可评论，不可开启 3暂时关闭，2或3即都不可评论
    commentsDisabled: (state) => state.commentsStatus !== 1
  },
  actions: {
    ...mutations,
    ...actions
  }
})
